import Cat from './Cat';
import User from './User';
import Category from './Category';
import Product from './Product';

export const cat = new Cat('cat');
export const user = new User('user');
export const category = new Category('categories');
export const product = new Product('product');